import React from 'react'
import { observer } from 'mobx-react'
import { CompProps } from '../../Editor'
import { PhoneInput } from '../commonQuestions/Phone'

const BusinessPhone: React.FC<CompProps> = (props) => {
  /* eslint-disable i18next/no-literal-string */
  return (
    <PhoneInput
      {...props}
      testID="BusinessPhoneInput"
      label="Business.PhoneLabel"
    />
  )
}

export default {
  title: 'Business.Phone',
  component: observer(BusinessPhone),
}
